import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';

export const DeleteFamilyCommunicationRequestDtoSchema = z.object({
  id: z.number(),
});

export type DeleteFamilyCommunicationRequestDto = z.infer<
  typeof DeleteFamilyCommunicationRequestDtoSchema
>;

export const deleteFamilyCommunication = (
  params: DeleteFamilyCommunicationRequestDto,
  config?: AxiosRequestConfig<DeleteFamilyCommunicationRequestDto>
) => {
  const { id } = params;
  return api.delete(`family-communication/${id}`, { ...config });
};
